import './style.scss';

// @ts-ignore: Stable API
import { useSettings } from '@wordpress/block-editor';
import { ColorPalette, Popover } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import React, { useMemo, useState } from 'react';

import { ColorPickerProps } from './types';

export const ColorPicker: React.FC< ColorPickerProps > = ( {
	value,
	onChange,
	className = '',
} ) => {
	const [ isOpen, setIsOpen ] = useState( false );

	const triggerRef = React.useRef< HTMLButtonElement >( null );

	const [ defaultColors, userColors, themeColors, coreColors ] = useSettings(
		'color.palette.default',
		'color.palette.user',
		'color.palette.theme',
		'color.palette.core',
	);

	const colors = useMemo( () => {
		const result = [];
		if ( coreColors && coreColors.length ) {
			result.push( {
				name: __( 'Core', 'fancy-blocks' ),
				colors: coreColors,
			} );
		}
		if ( themeColors && themeColors.length ) {
			result.push( {
				name: __( 'Theme', 'fancy-blocks' ),
				colors: themeColors,
			} );
		}
		if ( userColors && userColors.length ) {
			result.push( {
				name: __( 'User', 'fancy-blocks' ),
				colors: userColors,
			} );
		}
		if ( defaultColors && defaultColors.length ) {
			result.push( {
				name: __( 'Default', 'fancy-blocks' ),
				colors: defaultColors,
			} );
		}
		return result;
	}, [ defaultColors, userColors, themeColors, coreColors ] );

	const handleColorChange = ( color: string | undefined ) => {
		if ( onChange ) {
			if ( color ) {
				onChange( color );
			} else {
				onChange( undefined );
			}
		}
	};

	return (
		<div className={ `redfox-thank-you-color-picker ${ className }` }>
			<div className="redfox-thank-you-color-picker__controls">
				<button
					className="redfox-thank-you-color-picker__trigger"
					onClick={ () => setIsOpen( ! isOpen ) }
					style={ {
						// @ts-expect-error: Allow custom CSS property
						'--redfox-thank-you-color-picker-background':
							value || 'transparent',
					} }
					aria-label={ __( 'Open color picker', 'redfox-thank-you' ) }
					ref={ triggerRef }
				/>
			</div>

			{ isOpen && (
				<Popover
					placement="left-start"
					onClose={ () => setIsOpen( false ) }
					anchor={ triggerRef.current }
					className="redfox-thank-you-color-picker__popover"
					offset={ 20 }
				>
					<div className="redfox-thank-you-color-picker__content">
						<ColorPalette
							colors={ colors }
							value={ value }
							onChange={ handleColorChange }
							__experimentalIsRenderedInSidebar
							enableAlpha
							clearable
						/>
					</div>
				</Popover>
			) }
		</div>
	);
};
